<template>
  <div>
    <slot name="pageTitle" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'g-page-wrapper'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/components/GPageWrapper.vue